/**
 * Blog Article — Direction B "Pro / Outillage dark"
 * Transformations automatiques du contenu riche Shopify :
 * - Génération du sommaire (TOC) à partir des H2
 * - Transformation de la FAQ (H3 + P) en accordéon
 * - Transformation du bloc "À retenir" (H2 + UL) en encart dark
 */
(function () {
  'use strict';

  var textBlock = document.querySelector('.article-content .text-block.auto');
  if (!textBlock) return;

  /* -----------------------------------------------------------------------
     1. TOC — Sommaire auto-généré depuis les H2
     ----------------------------------------------------------------------- */
  function buildTOC() {
    var headings = textBlock.querySelectorAll(':scope > h2');
    if (headings.length < 3) return;

    var toc = document.createElement('nav');
    toc.className = 'blog-toc';
    toc.setAttribute('aria-label', 'Sommaire');

    var title = document.createElement('div');
    title.className = 'blog-toc__title';
    title.textContent = 'Sommaire';
    toc.appendChild(title);

    var list = document.createElement('ol');
    list.className = 'blog-toc__list';

    headings.forEach(function (h2, i) {
      var id = 'section-' + (i + 1);
      h2.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;

      var num = document.createElement('span');
      num.className = 'blog-toc__number';
      num.textContent = String(i + 1).padStart(2, '0');

      a.appendChild(num);
      a.appendChild(document.createTextNode(h2.textContent));
      li.appendChild(a);
      list.appendChild(li);
    });

    toc.appendChild(list);
    textBlock.insertBefore(toc, textBlock.firstChild);
  }

  /* -----------------------------------------------------------------------
     2. FAQ — Transformation H3 + P en accordéon
     ----------------------------------------------------------------------- */
  function buildFAQ() {
    var faqHeading = null;
    var headings = textBlock.querySelectorAll(':scope > h2');

    for (var i = 0; i < headings.length; i++) {
      if (/FAQ/i.test(headings[i].textContent)) {
        faqHeading = headings[i];
        break;
      }
    }

    if (!faqHeading) return;

    var faqContainer = document.createElement('div');
    faqContainer.className = 'blog-faq';

    var sibling = faqHeading.nextElementSibling;
    var pairs = [];
    var currentQ = null;

    while (sibling) {
      var next = sibling.nextElementSibling;

      if (sibling.tagName === 'H2') break;

      if (sibling.tagName === 'H3') {
        currentQ = sibling.textContent.trim();
      } else if (sibling.tagName === 'P' && currentQ) {
        pairs.push({ q: currentQ, a: sibling.textContent });
        currentQ = null;
      }

      sibling.remove();
      sibling = next;
    }

    pairs.forEach(function (pair) {
      var item = document.createElement('div');
      item.className = 'blog-faq__item';

      var question = document.createElement('div');
      question.className = 'blog-faq__question';
      question.textContent = pair.q;
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');

      var answer = document.createElement('div');
      answer.className = 'blog-faq__answer';
      answer.textContent = pair.a;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        question.setAttribute('aria-expanded', !isOpen);
      });

      question.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });

      item.appendChild(question);
      item.appendChild(answer);
      faqContainer.appendChild(item);
    });

    faqHeading.insertAdjacentElement('afterend', faqContainer);
  }

  /* -----------------------------------------------------------------------
     3. BLOC "À RETENIR" — Transformation en encart dark
     ----------------------------------------------------------------------- */
  function buildTakeaway() {
    var headings = textBlock.querySelectorAll(':scope > h2');
    var takeawayH2 = null;

    for (var i = 0; i < headings.length; i++) {
      var txt = headings[i].textContent.trim().toLowerCase();
      if (txt === 'à retenir' || txt === 'a retenir') {
        takeawayH2 = headings[i];
        break;
      }
    }

    if (!takeawayH2) return;

    var ul = takeawayH2.nextElementSibling;
    if (!ul || ul.tagName !== 'UL') return;

    var wrapper = document.createElement('div');
    wrapper.className = 'blog-takeaway';

    var title = document.createElement('div');
    title.className = 'blog-takeaway__title';
    title.textContent = '→ À retenir';

    wrapper.appendChild(title);

    ul.remove();
    wrapper.appendChild(ul);

    takeawayH2.replaceWith(wrapper);
  }

  /* -----------------------------------------------------------------------
     4. SMOOTH SCROLL pour les ancres TOC
     ----------------------------------------------------------------------- */
  function enableSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.blog-toc a');
      if (!link) return;

      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', link.getAttribute('href'));
    });
  }

  /* -----------------------------------------------------------------------
     INIT
     ----------------------------------------------------------------------- */
  buildTakeaway();
  buildFAQ();
  buildTOC();
  enableSmoothScroll();
})();
